function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
const BusinessUnitForm = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading,
    onCreated
  } = _ref;
  const {
    t
  } = useTranslation();
  const [newBusinessUnit, setNewBusinessUnit] = useState({
    name: ''
  });
  const dispatch = useDispatch();
  const handleChange = e => {
    const value = e.target.value;
    setNewBusinessUnit(_objectSpread(_objectSpread({}, newBusinessUnit), {}, {
      [e.target.name]: value
    }));
  };
  const handleAddBusinessUnit = async () => {
    try {
      const nbu = await businessUnitsService.create(company.id, newBusinessUnit);
      setCompany(_objectSpread(_objectSpread({}, company), {}, {
        business_units: [...(company.business_units || []), nbu]
      }));
      setNewBusinessUnit({
        name: ''
      });
      onCreated === null || onCreated === void 0 || onCreated();
    } catch (e) {
      dispatch(handleError(e));
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('new_business_unit')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "name",
    onChange: handleChange,
    value: newBusinessUnit.name,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: newBusinessUnit.name.length < 1,
    onClick: () => handleAddBusinessUnit(),
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    variant: "primary"
  }, t('add_new_business_unit')))))));
};
export default BusinessUnitForm;